var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { LOCAL_STORAGE_KEY } from 'src/shared/constants';
export var saveInLocalStorage = function (value, key) {
    if (key === void 0) { key = LOCAL_STORAGE_KEY; }
    try {
        var currentStored = getLocalStorage(key);
        var valueToStore = JSON.stringify(__assign(__assign({}, currentStored), value));
        localStorage.setItem(key, valueToStore);
    }
    catch (e) {
        console.error('An error occured during saving in local storage');
    }
};
export var getLocalStorage = function (key) {
    if (key === void 0) { key = LOCAL_STORAGE_KEY; }
    return JSON.parse(localStorage.getItem(key)) || {};
};
